import { useParams } from 'react-router-dom';
import { useTenantParams } from '@/hooks/use-tenant-params';
import { MailboxPanel } from '@/components/mailbox-panel';
import { PageContainer } from '@/components/page-container';
import { PageError } from '@/components/page-error';
import { PageHeader } from '@/components/page-header';
import { invalidateMe, useMe } from '@/hooks/use-me';

// =====================================================================
// Mailboxes — WP1 Task 7. Standalone home for components/mailbox-panel.tsx
// at businessRoutes.mailboxes(businessId, siteId) ("/app/b/:siteId/foundation/mailboxes").
// Previously MailboxPanel only rendered nested under the old site-domain.tsx
// page; the nav model (nav-model.ts) already treats Mailboxes as its own
// Foundation item, locked (with a link to routes.domainWizard — WP3b/D4's
// guided domain & mailbox wizard) until a domain is active — MailboxPanel
// itself now renders that locked-state explainer (see mailbox-panel.tsx)
// instead of silently rendering nothing, for the case where this route is
// reached directly.
// =====================================================================

export function Mailboxes() {
  const meState = useMe();
  const { businessId = '', locationId: siteId } = useTenantParams();

  if (meState.kind === 'error') {
    // Keeps the page's own identity — same eyebrow and <h1> as the ready
    // state below — when /api/me fails. See components/page-error.tsx.
    return (
      <PageError
        eyebrow="Foundation"
        title="Professional email"
        message={meState.message}
        retry={invalidateMe}
      />
    );
  }
  if (meState.kind !== 'ready' || !siteId) {
    return null;
  }

  return (
    <PageContainer>
      <PageHeader eyebrow="Foundation" title="Professional email" />

      <MailboxPanel siteId={siteId} />
    </PageContainer>
  );
}
